import _ from 'lodash'

const state = {
  value: {
    rate: {id: null, text: null},
    rules: {id: null, text: null},
    hscode: {id: null, text: null}
  },
  valueSync: {
    rate: true,
    rules: true,
    hscode: true
  },
  clear: false
}

const getters = {
  getRateValue (state, getters, rootState, rootGetters) {
    return state.value.rate
  },
  getRulesValue (state, getters, rootState, rootGetters) {
    return state.value.rules
  },
  getHsCodeValue (state, getters, rootState, rootGetters) {
    return state.value.hscode
  }
}

const mutations = {
  setRateValue (state, value) {
    if (_.isString(value)) {
      value = {id: null, text: null}
      state.valueSync.rate = true
    } else {
      state.valueSync.rate = false
    }
    state.value.rate = value
    this.dispatch('search/product/asyncProductValue', value)
  },
  setRulesValue (state, value) {

    if (_.isString(value)) {
      value = {id: null, text: null}
      state.valueSync.rules = true
    } else {
      state.valueSync.rules = false
    }
    state.value.rules = value
    this.dispatch('search/product/asyncProductValue', value)
  },
  setHsCodeValue (state, value) {
    if (_.isString(value)) {
      value = {id: null, text: null}
      state.valueSync.hscode = true
    } else {
      state.valueSync.hscode = false
    }
    state.value.hscode = value
    this.dispatch('search/product/asyncProductValue', value)
  },
  setRelValue (state, item) {
    state.value[item.activeTabName] = item.value
    state.clear = !state.clear
  },
  setClearValue (state) {
    state.clear = !state.clear
  },
  syncValue (state, item) {
    if (item.activeTabName !== 'rate') {
      if (state.valueSync.rate || _.isEmpty(state.value.rate.id)) {
        if (item.importerLen <= 1 || item.importerValues[item.activeTabName].id === item.importerValues.rate.id) {
          state.value.rate = item.value
        }
      }
    }
    if (item.activeTabName !== 'rules') {
      if (state.valueSync.rules || _.isEmpty(state.value.rules.id)) {
        if (item.importerLen <= 1 || item.importerValues[item.activeTabName].id === item.importerValues.rules.id) {
          state.value.rules = item.value
        }
      }
    }
    if (item.activeTabName !== 'hscode') {
      if (state.valueSync.hscode || _.isEmpty(state.value.hscode.id)) {
        if (item.importerLen <= 1 || item.importerValues[item.activeTabName].id === item.importerValues.hscode.id) {
          state.value.hscode = item.value
        }
      }
    }
  },
  resetValue (state, key) {
    if (state.value[key]) {
      state.value[key] = {id: null, text: null}
      state.valueSync[key] = true
    }
  }
}

const actions = {
  asyncProductState ({ commit, state, rootState }, value) {
    commit('setRelValue', {
      activeTabName: rootState.search.activeName,
      value: _.isString(value) ? {id: null, text: null} : value
    })
  },
  asyncProductValue ({ commit, rootState }, value) {
    commit('syncValue', {
      activeTabName: rootState.search.activeName,
      importerLen: rootState.data.importerAll.length,
      importerValues: rootState.search.importer.value,
      value: value
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/search/product.js